<!-- TwoStepScreen.vue -->
<template>
    <Screen :progress="progress">
      <Slide>
        <div style="background-color: #f0f0f0; padding: 15px; border-radius: 5px;">
          Hint: <br />
          <b>Answerable:</b> given your knowledge and the provided context, you can answer the question with a concrete / specific, not imagined answer. <br />
          <b>Not definitvely answerable:</b> no specific answer can be provided because the context is missing information, the question is nonsensical, underspecified or makes incorrect assumptions.<br />
        </div>
        <br />
        <div v-html="prepareContext(trial)" style="background-color: #f7e0e0; padding: 15px; border-radius: 5px;"></div>
        <br />
        <div style="background-color: #e3f2fd; padding: 15px; border-radius: 5px;">{{trial.context}}</div>
        <div class="choice-container" style="text-align: center; margin: 20px 0 20px 140px;">
          <MultipleChoiceInput
              :response.sync= "$magpie.measurements.fc"
              :options="['Answerable', 'Not definitively answerable']"
              :randomize="true"
          />
        </div>
          <p v-if="$magpie.measurements.fc">  
        
          Please write down your final answer to the task or why you consider it not answerable.
        <br />
          <textarea
            v-model="$magpie.measurements.final_answer"
            @input="recordFinalAnswerStartTime()"
            style="width: 500px; height: 50px"
          />
          <br />
          Please provide optional explanations of your solution steps.
           <br />
          <textarea
            v-model="$magpie.measurements.answer_explanation"
            @input="recordExplanationStartTime()"
            style="width: 500px; height: 200px"
          />
        
        <br />
        </p>
        <Record v-if="final_answer_start_time" :data="recordData" />
        <button
            v-if="
            $magpie.measurements.final_answer &&
            $magpie.measurements.final_answer.length >= 1
            "
            @click="submitTrial()"
        >
            Next
        </button>
      </Slide>
    </Screen>
</template>

<script>
import _ from "lodash";

function prepareContext(trial) {
  let context;
  if (trial.risk_condition === 'high_risk') {
    context = trial.instructions_high_risk + '<br />';
  } else if (trial.risk_condition === 'low_risk') {
    context = trial.instructions_low_risk + '<br />';
  } else {
    context = trial.instructions_default + '<br />';
  }
  return context;
};

export default {
  name: "TwoStepScreen",
//   components: { PieChart },
  props: {
    trial: Object,
    index: Number,
    // trial_type: String,
    progress: Number,
    //optionOrder: Array,
    // targetOption: String
  },
  computed: {
    recordData() {
      return {
        trialNr: this.index + 1,
        itemId: this.trial.item_id,
        missing_info_condition: this.trial.missing_info_condition,
        risk_condition: this.trial.risk_condition,
        is_solvable: this.trial.is_solvable,
        risk_prompt: this.trial.risk_prompt,
        domain: this.trial.domain,
        type: this.trial.type,
        correct_answer: this.trial.should_abstain,
        correct_answer_text: this.trial.GT_answer,
        difficulty: this.trial.difficulty,
        question_id: this.trial['Question ID'],
        category: this.trial.category,
        response_time_fc: this.fc_response_time,
        response_time_explanation: this.explanation_start_time ? this.explanation_start_time - this.start_time : null,
        response_time_text: this.final_answer_start_time ? this.final_answer_start_time - this.start_time : null,
      };
    }
  },
  data() {
    return {
      shuffledOptions: [],
      start_time: null,
      fc_response_time: null,
      explanation_start_time: null,
      final_answer_start_time: null,
      fc_time_recorded: false,
      final_answer_time_recorded: false,
      explanation_time_recorded: false,
    };
  },
  mounted() {
    this.shuffledOptions = _.shuffle(['Answerable', 'Not definitively answerable']);
    this.start_time = Date.now();
    console.log('start time', this.start_time);
  },
  watch: {
    '$magpie.measurements.fc'(newVal) {
      if (newVal && !this.fc_time_recorded) {
        this.fc_response_time = Date.now() - this.start_time;
        this.fc_time_recorded = true;
      }
    }
  },
  methods: {
    recordExplanationStartTime() {
      if (!this.explanation_time_recorded && this.$magpie.measurements.answer_explanation) {
        this.explanation_start_time = Date.now();
        this.explanation_time_recorded = true;
      }
    },
    recordFinalAnswerStartTime() {
      if (!this.final_answer_time_recorded && this.$magpie.measurements.final_answer) {
        this.final_answer_start_time = Date.now();
        this.final_answer_time_recorded = true;
      }
    },
    submitTrial() {
      // this.$magpie.addTrialData(this.recordData);
      this.$magpie.saveAndNextScreen();
    },
    prepareContext
  },

};

</script>

<style scoped>
.choice-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 20px auto;
  text-align: center;
}
</style>